import { render, staticRenderFns } from "./TheFooterAstagiudiziaria.vue?vue&type=template&id=7bc44840&scoped=true"
import script from "./TheFooterAstagiudiziaria.vue?vue&type=script&lang=ts"
export * from "./TheFooterAstagiudiziaria.vue?vue&type=script&lang=ts"
import style0 from "./TheFooterAstagiudiziaria.vue?vue&type=style&index=0&id=7bc44840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc44840",
  null
  
)

export default component.exports